import { api } from '@/config/api';

export interface ContactGroup { _id: string; groupUid: string; companyUid: string; name: string; slug: string; color: string; description?: string; contactCount: number; }

export const contactGroupsService = {
  list: async (): Promise<ContactGroup[]> => (await api.get('/slighter_crm/contact-groups')).data,
  get: async (uid: string, opts?: { expectedStatuses?: number[] }): Promise<ContactGroup> => (await api.get(`/slighter_crm/contact-groups/${uid}`, opts)).data,
  create: async (p: { name: string; description?: string; color?: string }): Promise<ContactGroup> => (await api.post('/slighter_crm/contact-groups', p)).data,
  update: async (uid: string, p: Partial<ContactGroup>): Promise<ContactGroup> => (await api.patch(`/slighter_crm/contact-groups/${uid}`, p)).data,
  remove: async (uid: string) => { await api.delete(`/slighter_crm/contact-groups/${uid}`); },
  members: async (uid: string, page = 1, limit = 50) => (await api.get(`/slighter_crm/contact-groups/${uid}/members`, { params: { page, limit } })).data,
};
